<template>
  <div
    class="table-cell"
    :class="{
      red: cellData?.quality === 'bad',
      green: cellData?.quality === 'good',
      dimension: column.column_type === 'DIMENSION',
      measure: column.column_type === 'MEASURE',
      total: cellData.is_total
    }">
    <i
      v-if="cellData.direction && cellData.direction !== 'none'"
      class="material-icons arrow-icon">
      {{ cellData.direction === "up" ? "arrow_upward" : "arrow_downward" }}
    </i>
    <b-tooltip
      :active="column.column_type === 'DIMENSION'"
      type="is-dark"
      position="is-right"
      multilined
      class="table-cell-tooltip"
      content-class="custom-tooltip-content">
      <template v-slot:content>
        {{ cellData.value }}
      </template>
      <span class="value">
        {{ cellData.value }}
      </span>
    </b-tooltip>
  </div>
</template>

<script>
  export default {
    name: 'TableCell',
    props: {
      cellData: {
        type: Object,
        required: true,
      },
      column: {
        type: Object,
        required: true,
      },
    },
  }
</script>

<style scoped>
.table-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 40px;
  border-right: 1px solid #e9e9ea;
  border-bottom: 1px solid #e9e9ea;
  text-align: center;
  padding: 0 10px;
  background-color: #fff;
  overflow: visible;
  cursor: default;

  &.dimension {
    text-align: left;
  }

  &.total {
    border-bottom: 1px solid #504F54;
    font-weight: 600;
  }
  &.measure {
    justify-content: end;
    font-family: "Inconsolata", monospace;
    font-weight: 500 !important;
    font-size: 14px;
  }

  &.green {
    color: #008c84;
    background-color: rgba(0, 140, 132, 0.05);
  }
  &.red {
    color: #d31b5e;
    background-color: rgba(211, 27, 94, 0.05);
  }
  .table-cell-tooltip {
    max-width: 100%;
    min-width: 0;
    flex: 0 1 auto;
    display: flex;
  }
  .value {
    display: block;
    max-width: 100%;
    min-width: 0;
    flex: 0 1 auto;
    overflow: hidden;
  }

  &.dimension .value {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .arrow-icon {
    font-size: 16px;
    margin-right: auto;
    flex-shrink: 0;
  }
}
</style>
